import { cn } from "@core-ui/utils/cn";
import { Indicator } from "@ui-kit/Indicator";
import { type ComponentProps, forwardRef } from "react";

export type AgentMessageIndicatorProps = Omit<ComponentProps<typeof Indicator>, "children" | "size" | "rounded">;

export const AgentMessageIndicator = forwardRef<HTMLDivElement, AgentMessageIndicatorProps>((props, ref) => {
	const { className, ...otherProps } = props;
	return (
		<Indicator
			className={cn(
				"absolute -bottom-1 -right-1 grid size-4 place-items-center select-none",
				"border border-alpha-10 bg-primary-fg text-[0.5rem] font-semibold leading-none text-primary-bg",
				className,
			)}
			ref={ref}
			rounded
			{...otherProps}
		>
			AI
		</Indicator>
	);
});
